import { BasketItemRequest } from "./basket-item.request.dto";


export class CheckBasketRequest {
  customer: Customer;
  startDate: Date;
  paymentProvider: string;
  items: BasketItemRequest[];
}

export class Customer {
  constructor(
    public isPrivatePerson: boolean,    
    public name: Name,
    public address: Address,
    public email: string,
    public confirmEmail: string,
    public phoneNumber?: string,
    public taxInfo?: TaxInfo,
    public companyName?:string
  ) { }
}

export class Name {
  constructor(
    public firstName: string,
    public lastName: string, 
  ) { }
}

export class Address {
  constructor(
    public countryCode: string,
    public zipCode: string,
    public city: string,
    public streetAndNumber: string,
    public region?: string,
  ) { }
}

export class TaxInfo {
  constructor(
    public taxNumber: string,
    public euTaxNumber?: string
  ) { }
}
